import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import profile from "./profile.module";
import global from "./global";
import user from "./user";
import menu from "./menu";
import wallet from "./wallet";
import tutorial from "./tutorials";
import localstorage from "./localstorage";
import chatAi from "./aichat/index";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    htmlClass,
    config,
    breadcrumbs,
    profile,
    global,
    user,
    menu,
    wallet,
    tutorial,
    localstorage,
    chatAi,
  },
});
